import { EventType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const eventTypeDictionary = createSimpleDictionary([
    { id: EventType.Live, name: 'dictionaries.eventType.live' },
    { id: EventType.Pregame, name: 'dictionaries.eventType.pregame' },
]);
